module.exports = __webpack_public_path__ + "img/ic_auto_rotate.dfc3e789.svg";